import React from "react";
import { NavLink } from "react-router-dom";

const cabecalho = (props) => {
	return (
		<>
			<div className={"navegacao-principal"}>
				<div className="navegacao-principal__logo">
					<NavLink to="/">
						<img src="/logo.png" alt="Metalife Pilates" />
					</NavLink>
				</div>
				<div className="navegacao-principal__titulo">{props.title}</div>
				<ul className="navegacao-principal__menu">
					{props.astecChamadoId && props.astecChamadoId !== "" && (
						<li onClick={props.voltarParaChamado}>voltar para o chamado</li>
					)}
					{!props.astecChamadoId &&
						props.pipedriveDealId &&
						props.pipedriveDealId !== "" && (
							<li onClick={props.voltarParaNegocio}>voltar para o negócio</li>
						)}
				</ul>
			</div>
		</>
	);
};

export default cabecalho;
